import { Alert } from 'antd';

import OrganizationFilter from '../../OrganizationFilter';

const OrganizationFilterBase = OrganizationFilter as any;

type MagicFlowOrgSelectorProps = {
  hasOrgSelected: boolean;
  disableSelector: boolean;
};

export const MagicFlowOrgSelector = ({
  hasOrgSelected,
  disableSelector,
}: MagicFlowOrgSelectorProps) => {
  return (
    <>
      <div className="flex justify-end items-center gap-2">
        <label className="text-md text-gray-600 font-medium">
          Select organization:
        </label>
        <OrganizationFilterBase disabled={disableSelector} />
      </div>

      {!hasOrgSelected && (
        <Alert
          className="mt-3"
          type="info"
          showIcon
          message="Select an organization to manage rulesets, workflow templates, and debugger runs."
        />
      )}
    </>
  );
};
